// Inform GTM Consent Mode when consent changes
function updateGtmConsent(granted: boolean) {
  try {
    // @ts-ignore
    const gtag = (window as any).gtag;
    if (typeof gtag === 'function') {
      gtag('consent', 'update', {
        ad_storage: granted ? 'granted' : 'denied',
        ad_user_data: granted ? 'granted' : 'denied',
        ad_personalization: granted ? 'granted' : 'denied',
        analytics_storage: granted ? 'granted' : 'denied',
      });
    }
  } catch {}
}
export const ANALYTICS_CONSENT_KEY = 'consent:analytics';

export function getAnalyticsConsent(): boolean | null {
  try {
    const raw = localStorage.getItem(ANALYTICS_CONSENT_KEY);
    if (raw === null) return null;
    return raw === 'true';
  } catch {
    return null;
  }
}

export function setAnalyticsConsent(value: boolean): void {
  try {
    localStorage.setItem(ANALYTICS_CONSENT_KEY, value ? 'true' : 'false');
    updateGtmConsent(value);
  } catch {
    // ignore storage errors
  }
}

